/**
 * Composio OAuth Callback Handler
 *
 * With the v0.6 hosted OAuth flow, Composio handles the provider callback
 * server-side — our frontend no longer brokers the code exchange. If the
 * browser ends up here (legacy bookmark, stale link, or manual navigation),
 * show a friendly message instructing the user to return to the main app.
 */

import { useEffect } from 'react'
import { CheckCircle2 } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

interface ComposioCallbackHandlerProps {
  onSuccess?: (appId: string) => void
}

export function ComposioCallbackHandler({ onSuccess }: ComposioCallbackHandlerProps) {
  useEffect(() => {
    const appId = new URLSearchParams(window.location.search).get('appId')
    onSuccess?.(appId ?? 'unknown')
  }, [onSuccess])

  return (
    <div className="flex items-center justify-center min-h-screen bg-warm-50">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle className="text-center">Connected</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4 text-center">
          <CheckCircle2 className="w-8 h-8 text-success-fg" />
          <p className="text-sm text-text-secondary">
            You can close this tab and return to Skerpa — the integration will
            appear in your Connected integrations list shortly.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
